import { actionTypes } from './constants';
import { curl } from 'zh-common-modules';
import { DOC_LIST_GET, DOC_TYPE_LIST_GET, DOC_CENTER_TREE_GET, DOC_CENTER_LIST_GET, DOC_FILE_HISTORY_POST, DOC_FILE_HISTORY_SHARE_GET, DOC_SHARE_IDS_GET } from 'src/fetch/url';

export const setDocList = (data) => ({
  type: actionTypes.SET_DOC_LIST,
  data,
});

export const setDocTypeList = (data) => ({
  type: actionTypes.SET_DOC_TYPE_LIST,
  data,
});

export const setDocCenterTree = (data) => ({
  type: actionTypes.SET_DOC_CENTER_TREE,
  data,
});

export const setDocCenterList = (data) => ({
  type: actionTypes.SET_DOC_CENTER_LIST,
  data,
});

export const getDocList = (params, cb) => {
  return dispatch => {
    curl.get(DOC_LIST_GET, params).then(res => {
      cb && cb(res);
      dispatch(setDocList(res));
    });
  };
};

export const getDocTypeList = (params, cb) => {
  return dispatch => {
    curl.get(DOC_TYPE_LIST_GET, params).then(res => {
      cb && cb(res);
      dispatch(setDocTypeList(res));
    });
  };
};

export const getDocCenterTree = (params, cb) => {
  return dispatch => {
    curl.get(DOC_CENTER_TREE_GET, params).then(res => {
      cb && cb(res);
      dispatch(setDocCenterTree(res));
    });
  };
};

export const getDocCenterList = (params, cb) => {
  return dispatch => {
    curl.get(DOC_CENTER_LIST_GET, params).then(res => {
      cb && cb(res);
      dispatch(setDocCenterList(res));
    });
  };
};

export const getDocHistory = (params, cb) => {
  return dispatch => {
    curl.get(DOC_FILE_HISTORY_POST, params).then(res => {
      cb && cb(res);
    });
  };
};

export const getDocShare = (params, cb) => {
  return dispatch => {
    curl.get(DOC_FILE_HISTORY_SHARE_GET, params).then(res => {
      cb && cb(res);
    });
  };
};

export const getDocShareIds = (params, cb) => {
  return dispatch => {
    curl.get(DOC_SHARE_IDS_GET, params).then(res => {
      cb && cb(res);
    });
  };
};
